import { vservice } from '@niknevis/vue-modules'
import { MediaService } from '@/modules/media/services/media.service'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'

@vservice()
export class MediaDeleteUseCase {
  constructor(
    private readonly service: MediaService
  ) {
  }

  private remoteData = RemoteData.notAsked()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get getErrorMessage() {
    return this.remoteData.fold(
      () => null,
      () => null,
      () => null,
      error => error
    )
  }

  execute(mediaId: number) {
    return this.remoteData.fromPromise(
      this.service.deleteMedia(mediaId)
    )
  }
}
